import html2pdf from 'html2pdf.js';

import { activateAllTabs, restoreTabs, activateAllAccordions, restoreAccordions } from '../functions';

document.addEventListener('DOMContentLoaded', () => {
    const printLinks = document.querySelectorAll('.is-download');

    printLinks.forEach(printElement => {
        printElement.addEventListener('click', async () => {
            printElement.classList.add('is-loading');
            const element = document.body;

            const tabState = activateAllTabs();
            const accordionState = activateAllAccordions();

            await new Promise(resolve => setTimeout(resolve, 200));

            printElement.classList.remove('is-loading');

            await html2pdf()
                .set({
                    margin: 1,
                    html2canvas: { scale: 1.5 },
                    jsPDF: { unit: 'mm', format: 'letter', orientation: 'portrait' },
                    pagebreak: { mode: ['avoid-all'] },
                })
                .from(element)
                .saveAs('score.pdf');

            restoreTabs(tabState);
            restoreAccordions(accordionState);
        });
    });
});
